
export function workspaceNotificationViewed (workspace, user) {
  window.analytics.track('Workspace Notifications Viewed', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    workspace_name: workspace.name,
    user_email: user.email,
    user_full_name: user.name
  })
}

export function workspaceNotificationBodyClicked (workspace, user, category, title) {
  window.analytics.track('Workspace Notifications Clicked', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    workspace_name: workspace.name,
    user_email: user.email,
    user_full_name: user.name,
    category: category,
    title: title
  })
}

export function workspaceNotificationUxClicked (workspace, user) {
  window.analytics.track('Workspace Notifications Clicked', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    workspace_name: workspace.name,
    user_email: user.email,
    user_full_name: user.name,
    category: 'UX Research Program'
  })
}



// WEBPACK FOOTER //
// ./analytics/workspace-notifications.js